var map = {
	"./007-microphone-1.png": "6316",
	"./01-medal-gold.svg": "b991",
	"./010-home.png": "014e",
	"./013-document-1.png": "f53e",
	"./014-document.png": "0b9f",
	"./015-color-palette.png": "8233",
	"./017-video-camera.png": "f43d",
	"./02-medal-silver.svg": "0d62",
	"./024-like.svg": "fca6",
	"./03-medal-bronze.svg": "ae35",
	"./1.svg": "d33c",
	"./155-credit-card.svg": "d049",
	"./2.svg": "a8d8",
	"./3.svg": "cbdb",
	"./4.svg": "b0dd",
	"./New Customer.svg": "2a2d",
	"./NotOpen.svg": "121e",
	"./Opened.svg": "7127",
	"./Profit.svg": "fea3",
	"./SalesRevenue.svg": "5ce3",
	"./Sent.svg": "f815",
	"./Slack.svg": "2af9",
	"./address.svg": "b321",
	"./adobe.svg": "bdc7",
	"./anonymous-profile.svg": "863c",
	"./arrow-left.svg": "9092",
	"./arrow-right.svg": "9d8b",
	"./bar-chart-blue.svg": "6eab",
	"./bar-chart.svg": "84d5",
	"./book.svg": "ca8d",
	"./camera.svg": "5d64",
	"./chat.svg": "7862",
	"./clipboard.svg": "9eea",
	"./cloud.svg": "ae80",
	"./columns.svg": "cc7c",
	"./content.png": "a4a3",
	"./delete.svg": "5bcd",
	"./documentation.svg": "e08b",
	"./exclude-keyword.svg": "ffe0",
	"./export-download.svg": "facf",
	"./export-redownload.svg": "0978",
	"./file.svg": "dc95",
	"./flat.svg": "fb17",
	"./font-case.svg": "0376",
	"./grey-setting.svg": "1a8f",
	"./headphone.svg": "1df1",
	"./icon-keywords.svg": "de13",
	"./icon-sliders.svg": "818a",
	"./icon-sources.svg": "4f89",
	"./icon-user-accounts.svg": "118c",
	"./iconfinder_trello_2317760.svg": "1d72",
	"./idea.svg": "babd",
	"./image.png": "32d3",
	"./image.svg": "38b6",
	"./keyword.svg": "bc48",
	"./label.png": "cbf5",
	"./layers.svg": "31d1",
	"./left.svg": "5a47",
	"./logo2.svg": "c803",
	"./logo3.svg": "f6b2",
	"./logo4.svg": "14ef",
	"./logo5.svg": "32aa",
	"./logo6.svg": "c46f",
	"./logoIn.svg": "3deb",
	"./paint.svg": "42e3",
	"./protection.svg": "b86e",
	"./quote.png": "57d4",
	"./repeat.svg": "76f5",
	"./right.svg": "5138",
	"./settings.svg": "c66a",
	"./sort.svg": "80db",
	"./strategy.svg": "8c26",
	"./theme.svg": "9bee",
	"./user.svg": "ce7b",
	"./water-fall.svg": "0884",
	"./x-circle.svg": "f987"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1407";